export function ButtonforPh(props) {
  return (
    <div className="bottom-informationph">
      <div className="center-boxph">
        <div className="bottomcontentlineone">
          <div className="logoleft"></div>
          <div className="social-list">
            <a
              href="https://www.cctalk.com/m/group/82776894"
              rel="noreferrer"
              target="_blank"
            >
              <div className="social-icon-cc"></div>
            </a>
            <a
              href="https://space.bilibili.com/181578039"
              rel="noreferrer"
              target="_blank"
            >
              <div className="social-icon-bilibili"></div>
            </a>
            <a
              href="https://www.weibo.com/u/1926245291"
              rel="noreferrer"
              target="_blank"
            >
              <div className="social-icon-weibo"></div>
            </a>
            <a
              href="https://www.zhihu.com/org/kkmo-fa-xue-yuan"
              rel="noreferrer"
              target="_blank"
            >
              {" "}
              <div className="social-icon-zhihu"></div>
            </a>
            {/* <a href="https://www.artstation.com/krenz" rel="noreferrer" target="_blank"><div className="social-icon-art"></div></a> */}
          </div>
        </div>
        <div className="bottomcontentlinetwo">
          <div className="lineonetext">
            KRENZ'S ARTWORK
            拥有业界十余年丰富教学经验，深入浅出的独创授课方式获得同学青睐。
          </div>
          <div className="linetwotext">
            KRENZ'S ARTWORK WITH MORE THAN TEN YEARS OF TEACHING EXPERIENCE IN
            THE INDUSTRY
          </div>
          <div className="linethreetext">
            THE ORIGINAL TEACHING METHOD IN SIMPLE LANGUAGE IS FAVORED BY
            STUDENT
          </div>
        </div>
        <div className="bottomcontentlinethree">
          <div className="versioninfor">
            <div>
              <span>
                <span className="contactname">联系我们</span>
                <span>商务合作邮箱：crystalli963@163.com</span>
              </span>
            </div>
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/recordQuery"
                style={{ color: "#979797" }}
              >
                沪ICP备20009980号-1
              </a>
              <span>COPYRIGHT</span>
              <span>©</span>
              <span>2025</span>
              <span>厚薄</span>
              <span>All</span>
              <span>RIGHTS</span>
              <span>RESERVED</span>
            </div>
          </div>

          <div className="contactussub">
            <div className="erweicodeimg">
              <img
                alt="jiazaizhong"
                width="100%"
                height="100%"
                src={"/latesterweicode.jpg"}
              />
            </div>
            <div>Krenz绘画教室</div>
          </div>
        </div>
      </div>
    </div>
  );
}
